import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { ClientesService } from '../../services/clientes.service';
import { ClientesEditComponent } from '../clientes-edit/clientes-edit.component';
import { AdvancedLookupComponent } from '../../models/lookup';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';
import { ApiResult } from './../../models/ApiResult';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent implements OnInit, AdvancedLookupComponent {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;
  isModal: boolean;
  dialogConfig: MatDialogConfig;

  public defaultColDef = {
    // set every column width
    width: 100
    // Nota: los filtros por columna (agTextColumnFilter) no funcionan con rowModelType 'infinite'
    // salvo que se reenvíe el filterModel al backend; se retiran para no mostrar un filtro que no filtra.
  };

  public rowData: any;
  searchTerm: FormControl = new FormControl();
  private readonly pageSize = 100;

  // Textos del panel de paginación de ag-Grid (por defecto vienen en inglés).
  public localeText = {
    page: 'Página',
    more: 'más',
    to: 'a',
    of: 'de',
    next: 'Siguiente',
    last: 'Última',
    first: 'Primera',
    previous: 'Anterior'
  };

  createColumnDef() {
    const columnDefs = [
      {
        colId: 'accionEliminar',
        headerName: 'Eliminar', field: 'id', suppressFilter: true, suppressSorting: true,
        template: `<a data-action-type="remove"><i data-action-type="remove" class="fa fa-remove text-danger"></i></a>`,
        width: 35
      },
      {
        colId: 'accionEditar',
        headerName: 'Editar', field: 'id', cellClass: 'grid-opendialog', suppressSorting: true,
        template: `<i class="fa fa-edit text-info"></i>`,
        width: 50
      },
      { headerName: 'Seleccionar', width: 50, hide: true, suppressSorting: true },
      { headerName: this.translate.instant('clientes.ag_estado'),
          field: 'activo', width: 30, suppressSorting: true, cellRendererFramework: CellImageFormatterComponent, cellRendererParams: { modo: 'isActivo' } },
      { colId: 'id', headerName: this.translate.instant('clientes.ag_id'), field: 'id', width: 30, filter: 'agNumberColumnFilter' },
      { headerName: this.translate.instant('clientes.ag_nombre'), field: 'displayName', minWidth: 450, filter: 'agTextColumnFilter' },
      { headerName: this.translate.instant('clientes.ag_tipo'), field: 'customerTypeName', width: 60 },
      { headerName: this.translate.instant('clientes.ag_direccion'), field: 'address1', minWidth: 150, filter: 'agTextColumnFilter' },
      { headerName: this.translate.instant('clientes.ag_cifNif'), field: 'vatNumber', minWidth: 150, filter: 'agTextColumnFilter' },
      { headerName: this.translate.instant('clientes.ag_telf'), field: 'telHome', minWidth: 150, filter: 'agTextColumnFilter' }
    ];

    return columnDefs;
  }

  constructor(private _ClientesService: ClientesService, private _router: Router, private _route: ActivatedRoute,
    private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.maxWidth = '700px'
  }

  ngOnInit() {
    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {
        this.refreshData();
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.createDatasource());
    this.gridApi.sizeColumnsToFit();
  }

  private createDatasource() {
    return {
      getRows: (params) => {
        this._ClientesService.getClientesPaged(
          this.searchTerm.value, params.startRow, params.endRow, params.filterModel, params.sortModel).subscribe(
          result => {
            params.successCallback(result.rows, result.totalCount);
          },
          err => {
            console.error('Error al recuperar datos de clientes', err);
            params.failCallback();
          });
      }
    };
  }

  private refreshData() {
    if (this.gridApi) {
      this.gridApi.setDatasource(this.createDatasource());
    }
  }

  private hasSelectedRow(): boolean {
    console.log(this.gridApi.getSelectedNodes().length);
    return (this.gridApi.getSelectedNodes().length === 1);
  }

  public newItem() {
    const ref = this._dialog.open(ClientesEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this.refreshData();
    });
  }

  public onCellClickedEvent($event) {
    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf('grid-opendialog') >= 0 ) {
      const dlgRef = this._dialog.open(ClientesEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this.refreshData();
      });
    }
  }

  onActionAddClick(data: any) {
    var ans = confirm("Quieres añadir el registro con Id: " + data.id)
    if (ans) {
      this._ClientesService.removeCliente(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Este cliente ya está creado");
        }
        this.refreshData();
      });
    }
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._ClientesService.removeCliente(data.id).subscribe((data: ApiResult) => {
        if (data.correct == false) {
          alert("Este cliente está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
        this.refreshData();
      });
    }
  }

  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      console.log(rowid);
      return rowid;

    } else {
      return null;
    }
  }
}
